/*
* Project: xpenser-client
* FilePath: /src/app/components/header/index.tsx
* File: index.tsx
* Created Date: Friday, September 18th 2020, 7:30:30 pm
* Author: Craig Bojko (craig@pixelventures.co.uk)
* -----
* Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React from 'react'
import {
  AppBar,
  IconButton,
  Toolbar,
  Typography
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'

import { IHeader } from '@common/interfaces/iHeader'

export const Header: React.FC<IHeader> = ({ toggleNav }) => (
  <AppBar position='fixed'>
    <Toolbar>
      <IconButton edge='start' color='inherit' aria-label='menu' onClick={toggleNav}>
        <MenuIcon />
      </IconButton>
      <Typography variant='h6'>
        Xpenser
      </Typography>
    </Toolbar>
  </AppBar>
)

export default Header
